/** `m:ss`, matching the Android cards' `formatMinutesSeconds`. */
export function formatMinutesSeconds(totalSeconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/** Seconds until an ISO-8601 instant, floored at zero. Returns 0 for anything unparsable. */
export function secondsUntil(isoInstant: string): number {
  const target = Date.parse(isoInstant);
  if (Number.isNaN(target)) return 0;
  return Math.max(0, Math.floor((target - Date.now()) / 1000));
}

/** Local date+time for a device's `enrolledAt`/`lastSeenAt`; empty for a missing value. */
export function formatTimestamp(isoInstant: string | null | undefined): string {
  if (!isoInstant) return '';
  const parsed = Date.parse(isoInstant);
  if (Number.isNaN(parsed)) return '';
  return new Date(parsed).toLocaleString('de-CH', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}
